<template>
  <div class="table-settings">
    <div class="table-list-header">
      <div class="text-2xl font-semibold text-vp-base-900">
        Roles
      </div>
      <router-link
        :to="{ name: 'RoleNew' }"
        class="hover:no-underline"
      >
        <div
          class="flex items-center justify-center fixed bottom-16 right-16 w-14 h-14 sm:h-37 sm:w-30 sm:static bg-vp-primary-900 rounded-full sm:rounded-lg"
        >
          <span class="hidden sm:inline-block text-vp-base-100 text-sm font-semibold">Add</span>
          <Plus class="sm:hidden text-vp-base-100 h-6 w-6" />
        </div>
      </router-link>
    </div>

    <div
      v-if="rolesLoading"
      class="text-center"
    >
      Loading...
    </div>

    <div
      v-else
      class="table-list"
    >
      <div class="table-list-item">
        <div class="header-name">
          Name
        </div>
      </div>

      <router-link
        v-for="teamRole in teamRoles"
        :key="teamRole.id"
        :to="{ name: 'RoleEdit', params: { roleId: teamRole.id } }"
        class="table-list-item table-link"
      >
        <div class="table-cell-content">
          {{ teamRole.name }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTeamRolesStore } from '@/stores/team-roles';
import { Plus } from 'mdue';
import { computed } from 'vue';
import { useRootStore } from '@/stores/root';

const rootStore = useRootStore();
const rolesStore = useTeamRolesStore();
rolesStore.fetchAllTeamRoles(rootStore.currentAccountId);
const teamRoles = computed(() => rolesStore.teamRoles);
const rolesLoading = computed(() => rolesStore.loading);
</script>
